import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AidPurchaseFormEnum, SupportingMeasures } from '@isophi/mng-api';

import { ChildSupportingMeasureForm } from '../../constants/forms';

@Component({
  selector: 'app-child-supporting-measure-form',
  templateUrl: './child-supporting-measure-form.component.html',
  styleUrls: ['./child-supporting-measure-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChildSupportingMeasureFormComponent {
  @Input() formGroup: FormGroup<ChildSupportingMeasureForm>;
  @Input() allowRemove: boolean;
  @Input() supportingMeasureOptions: SupportingMeasures[];

  @Output() remove: EventEmitter<void> = new EventEmitter<void>();

  protected aidPurchaseForm: AidPurchaseFormEnum[] = Object.values(AidPurchaseFormEnum);

  protected removeSupportingMeasure(): void {
    if (!this.allowRemove) {
      return;
    }
    this.remove.emit();
  }

  searchMeasurements(term: string, item: any) {
    term = term.toLowerCase();
    return item.longName.toLowerCase().includes(term) || item.code.toLowerCase().includes(term);
  }
}
